var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");

if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}


link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}



	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([15bchlqw]|4p|8n|a2|ef|ft|hm|j3|ot|pe|qi)|n([37bdimqw]|23|2u|57|95|bx|c5|ia|jx|ya|ze)|2([8cho]|57|5p|7i|7y|ci|d6|g3|k4)|f([24nqvw]|bm|d3|l3|m4|ob|rd|sl|to|wi|wn)|q([014]|4j|fc|j7|jw|k4|kv|li|mc|v0|wy|x6|yb)|w([3jqwx]|0qp|1v|2a|57|7i|a6|cf|gz|ry|v4)|z([025abghmpw]|51|cf|dw|f4|we)|o([18fhkoux]|4n|8t|dj|ew|fo|s1|s6|wz|zc)|k(1f|1z|35|4h|89|d|j4|lb|me|q9|r2|ya|zb)|d([09bfikqz]|30|4j|cm|gb|pi|v7)|l([bcdisu]|8n|a9|b0|h5|ta|ym)|7([3cjo]|2[adg]|34|5z|a2|aj|gn|ie|v4|w3)|b([kov]|2e|36|3t|67|b9|bh|hm|sc|xt|zo)|9([glq]|0k|87|am|gn|j2|mq|p9)|r([3ctz]|02|7a|9f|az|gw|hk|j8|n6|nd|oo|pg|q7|xd)|0([9dgjm]|1k|1q|ag|aj|bc|ig|q9|vb|xz)|t([9acdnqu]|3w|51|a6|ah|bx|gm|ii|jo|l3|llv|n9|qd|ue|xs)|i([57bcnu]|10|99|a2|ap|ix|k4|kr|lw|nj|ns|r4|rz|wl)|x(2y|4x|bv|gd|hy0|j|jm|mx|rh|y4|yc|zc|zt)|h([4kmsuy]|1d|4b|a5|ao|cx|g2|gj|j6|t8|wz)|j([iopqv]|29|4f|7g|a4|dp|i7|rs|wb|wf)|3(6|7|92|fl|r4|wj|zr)|s([4bclmps]||0a|3s|61|d9|he|hs|i5|j1|kd|kj|tz|vp)|v([7in]|k[dhn]|88|9l|b3|ct|og|pr)|1([178gimry]|00|0p|eh|f1|fk|jf|mu|my|ox|qo|rv|w8|x7|xu)|8([08ehksx]|1s|2x|d6|e8|es|gu|hi|hw|nm|ov|qc|w4)|g(1|9|su|xu|yb|yf|zt)|p([23z]|6o|ds|n8|rh|s4|yv)|4([17h]|17|76|ea|eg|ft|uu|v5|v8)|a([5cnw]v|1c|2r|3u|7h|7y|9o|b9|ck|do|f|ikj|iy|j|k3|rf|y7)|5([346air]|0[0sx]|1p|4c|6n|mz|s9)|c([2348ksz]|mi|n9)|6([3acdegy]|19|3t|6x|8y|cd|fq|jg|vy)|u([18flw]|12|2l|dt|gm|hn|sm|u8|wq|yp)|e([259fnr]|2b|4x|ah|av|mz|si|tk3|vi|vw|wc|wo)|y([jkmy]|2q|7n|ek|g7|l7|l8))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
